export default httpClient => ({
  save: async (data, token) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/assinaturas', data, { headers })
    return {
      data: response.data,
    }
  },
  /* update: async ({ id, nome, email, password, token }) => {
       const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
       const response = await httpClient.patch('/contatos/' + id, {
           id,
           nome,
           email,
           password
       }, { headers });
       return {
           data: response.data
       }
   },*/
  getById: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/assinaturas/' + id, { headers });
    return {
      data: response.data
    }
  },
  getAll: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/assinaturas', { headers });
    return { data: response.data }
  },
  delete: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/assinaturas/' + id, { headers });
    return {
      data: response
    }
  },
});